// filecoin
const axios = require('axios')
const FileSaver = require('file-saver');

const { v4: uuidv4 } = require('uuid');

const base = 'https://api.nft.storage'
const scrt = process.env.REACT_APP_NFT_STORE_APIK
const head = {
  Authorization: `Bearer ${scrt}`
}

const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {type: contentType});
  return blob;
}


export const CreateFileLink = async (file) => {

  try {
    const basx = `${base}/upload`
    let result = await axios.post(basx, file, {headers:head})
    return (
      (result.data.ok && {
          cidx: result.data.value.cid,
          urla: `https://ipfs.io/ipfs/${result.data.value.cid}`,
          urlb: `https://${result.data.value.cid}.ipfs.dweb.link`,
        }) ||
      ''
    )
  } catch (error) {
    return null
  }
 
}


export const GetMetadataLink = async (item) => {

  const tokendata = {
    "name": item.name,
    "description": item.memo,
    "file_url": item.urli,
    "external_url": item.urle,
    "animation_url": item.urla,
    "custom_fields" : {},
    "attributes": []
  }
  console.log ('meta: ', tokendata)

  var blob = new Blob([JSON.stringify(tokendata)], {type: "application/json;charset=utf-8"});
  // saveAs(blob, `wise-${info.wise}.json`);

  const res = await CreateFileLink(blob)
  return {linx: `https://nftstorage.link/${res.cidx}`}
}


export const GetMediaLinx = async (item) => {
  // file comes in base64 
  const enid = uuidv4().split('-').join('')
  const name = item.name ??= enid;

  const blob = b64toBlob(item.file.split('base64,')[1], "image/png;");
  FileSaver.saveAs(blob, `${name}.png`);  
  
  const res = await CreateFileLink(blob)
  console.log (res)

  return {linx: `https://nftstorage.link/${res.cidx}`}

}